import { Component, OnInit, Input, ViewChild } from '@angular/core';

// View
import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { WoProductType } from 'src/app/shared/interfaces/wo-product-type';

// Service
import { WoProductTypeCrudService } from 'src/app/shared/services/wo-product-type-crud.service';
import { environment } from 'src/environments/environment';

// Class
@Component({
  selector: 'app-wo-product-type',
  templateUrl: './wo-product-type.component.html',
  styleUrls: ['./wo-product-type.component.scss']
})
export class WoProductTypeComponent implements OnInit {

  // Config
  public modules = environment.modules;

  // Model
  woProductTypes: WoProductType[];
  woProductType: WoProductType;
  selectedWoProductTypes: WoProductType[] = [];

  // Dialog for add and edit
  woProductTypeDialog: boolean = false;

  // Dialog for a recipe / creation of object
  woProductTypeCreationDialog: boolean = false;
  list1: any[];
  originalList1: any[];
  list2: any[];

  woProductTypeDryDialog: boolean = false;
  listDry1: any[];
  originalListDry1: any[];
  listDry2: any[];

  // Diloags
  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private woProductTypeService : WoProductTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Product types'}
    ];

    this.woProductTypes = [];
    this.woProductType = { } as WoProductType ;

    this.list1 = [ 
      // {'name':'Orange'} ,
      // {'name':'Pear' } ,
    ];
     this.originalList1 = Object.assign([], this.list1);
     this.list2 = [];

     this.listDry1 = [];
     this.originalListDry1 = Object.assign([], this.listDry1);
     this.listDry2 = [];
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.woProductTypeService.getWoProductTypesList(); 
    s.snapshotChanges().subscribe(data => {
      this.woProductTypes = [];
      this.originalList1 = [];
      this.originalListDry1 = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          const productType = jsonItem as WoProductType;
          const productType2 = Object.assign({}, productType);
          const productType3 = Object.assign({}, productType);
          
          this.woProductTypes.push(productType);

          if(productType2.transformable) {
            this.originalList1.push(productType2);
          }

          if(productType2.dryable) {
            this.originalListDry1.push(productType3);
          }
          
        }
      })
    })
    this.woProductTypes = this.woProductTypes.sort((a, b) => (a.name < b.name) ? -1 : 1);
    this.originalList1 = this.originalList1.sort((a, b) => (a.name < b.name) ? -1 : 1);
    this.originalListDry1 = this.originalListDry1.sort((a, b) => (a.name < b.name) ? -1 : 1);


    // column management
    this.cols = [
      { field: 'name', header: 'Name' }
    ];

    if (this.modules.purchase) { 

    }
    
    if (this.modules.receive) { 
      this.cols.push({ field: 'receivable', header: 'Can be received' });
    }

    if (this.modules.dry) {
      this.cols.push({ field: 'dryable', header: 'Can be dryied' }) ;
      this.cols.push({ field: 'dried', header: 'Is dried' });
    }

    if (this.modules.move) {
      //this.cols.push({ field: 'movable', header: 'Can be moved' }) ;
    }

    if (this.modules.transform) { 
      this.cols.push({ field: 'transformable', header: 'Can be transformed' });
      this.cols.push({ field: 'transformed', header: 'Is transformed' });
    }

    if (this.modules.wo) { 
      this.cols.push({ field: 'code', header: 'Sales code' });
      this.cols.push({ field: 'lastCode', header: 'Last code' });
    }

    this.cols.push({ field: 'soldable', header: 'Can be sold' });
    this.cols.push({ field: 'enabled', header: 'Enabled' });
    this.cols.push({ field: 'actions', header: 'Actions' } );

    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'lastCode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
    this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
        
    } );
  }

  dataState() {     
    this.woProductTypeService.getWoProductTypesList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.WoProductTypes);
            doc.save('product-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.woProductTypes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "product-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedWoProductTypes, 'product-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.woProductType = {} as WoProductType;
    this.submitted = false;
    this.woProductTypeDialog = true;
  }

  deleteSelectedWoProductTypes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected Content Types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.woProductTypes = this.woProductTypes.filter(val => !this.selectedWoProductTypes.includes(val));
          this.selectedWoProductTypes = [];
          this.woProductTypes.forEach( pt => {
            this.woProductTypeService.deleteWoProductType(pt.$key);
          } );
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content types deleted', life: 3000});
      }
  });
  }

  editWoProductTypeDrying(woProductType: WoProductType) {
    this.woProductType = {...woProductType};
    this.woProductTypeDryDialog = true;
    this.listDry1 = [];
    this.listDry1 = Object.assign([], this.originalListDry1);

    this.listDry1 = this.listDry1.sort((a, b) => (a.name < b.name) ? -1 : 1);

    
    // remove what is in list2
    this.listDry2 = [];
    this.listDry2 = Object.assign([], woProductType.dryableInputs);
    this.listDry2.forEach( item => item.$key = item.key);

    this.listDry2 = this.listDry2.sort((a, b) => (a.name < b.name) ? -1 : 1);


    this.listDry1 = this.listDry1.filter(
      (item, index) => {
        for( let item2 of this.listDry2) {
          if ( item2.key === item.$key) {
            return false;
          }
        }
        return true;
      }
    );

    this.listDry1 = this.listDry1.sort((a, b) => (a.name < b.name) ? -1 : 1);


    // console.log('EDIT DRY l1', this.list1);
    // console.log('EDIT DRY l2', this.list2);
    // console.log('EDIT DRY ld1', this.listDry1);
    // console.log('EDIT DRY ld2', this.listDry2);
  }

  editWoProductTypeCreation(woProductType: WoProductType) {
    this.woProductType = {...woProductType};
    this.woProductTypeCreationDialog = true;
    this.list1 = [];
    this.list1 = Object.assign([], this.originalList1);

    this.list1 = this.list1.sort((a, b) => (a.name < b.name) ? -1 : 1);

    // remove what is in list2
    this.list2 = [];
    this.list2 = Object.assign([], woProductType.inputs);
    this.list2.forEach( item => item.$key = item.key);

    this.list2 = this.list2.sort((a, b) => (a.name < b.name) ? -1 : 1);


    this.list1 = this.list1.filter(
      (item, index) => {
        for( let item2 of this.list2) {
          if ( item2.key === item.$key) {
            return false;
          }
        }
        return true;
      }
    );

    this.list1 = this.list1.sort((a, b) => (a.name < b.name) ? -1 : 1);


   

  //   this.list1 = this.list2.reduce(function(acc, item, index) {
  //     if (!this.list1.includes(index)) {
  //         acc.push(item);
  //     }
  //     return acc;
  // }, []);

  }

  editWoProductType(woProductType: WoProductType) {
    this.woProductType = {...woProductType};
    this.woProductTypeDialog = true;
  }

  deleteWoProductType(woProductType: WoProductType) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + woProductType.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.woProductTypes = this.woProductTypes.filter(val => val.$key !== woProductType.$key);
            this.woProductType = {} as WoProductType;
            this.woProductTypeService.deleteWoProductType(woProductType.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Product Type Deleted', life: 3000});
        }
    });
  }

  hideDryDialog() {
    this.woProductTypeDryDialog = false;
    this.submitted = false;
  }

  hideCreationDialog() {
    this.woProductTypeCreationDialog = false;
    this.submitted = false;
  }

  hideDialog() {
    this.woProductTypeDialog = false;
    this.submitted = false;
  }

  saveWoProductType() {
    this.submitted = true;

    if (this.woProductType.$key) {
      this.woProductTypes[this.findIndexById(this.woProductType.$key)] = this.woProductType;                
      this.woProductTypeService.updateWoProductType(this.woProductType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Updated', life: 3000});
    } else {
      // this.pallet.id = this.createId();
      // this.pallet.image = 'product-placeholder.svg';
      this.woProductType.position = this.woProductTypes.length;

      this.woProductTypeService.addWoProductType(this.woProductType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Created', life: 3000});
      this.woProductTypes = [...this.woProductTypes];
    }
    this.woProductTypeDialog = false;
    this.woProductType = { } as WoProductType;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.woProductTypes.length; i++) {
        if (this.woProductTypes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeWoProductType(woProductType : WoProductType) {
    const woProductTypeTmp = {
      ...woProductType
    };
    console.log("SAVE", woProductTypeTmp);
    this.woProductTypeService.updateWoProductType(  woProductTypeTmp );
  }

  moveToTargetDry(event: any) {
    //(onMoveToTarget)="moveToTarget($event)"
    console.log('Moved All Items: ', event.items);
    //this.confirm({} as Event, event.items);
    this.listDry2 = [...new Set(this.listDry2)];
   }


  moveToTarget(event: any) {
    //(onMoveToTarget)="moveToTarget($event)"
    console.log('Moved All Items: ', event.items);
    //this.confirm({} as Event, event.items);
    this.list2 = [...new Set(this.list2)];
   }
 
  //  confirm(event: Event, items : any[]) {
  //   this.confirmationService.confirm({
  //       target: event.target || undefined,
  //       message: 'Are you moving the entire product?',
  //       icon: 'pi pi-exclamation-triangle',
  //       accept: () => {
  //           //confirm action
  //       },
  //       reject: () => {
  //           //reject action
  //           if (items) {
  //             items.forEach( item => {
                
  //               const found = this.list1.find((litem) => {
  //                 return litem.name === item.name && litem.batch === item.batch;
  //               });
                
  //               console.log(found); // 👉️ {id: 1, name: 'Alfred'}
                
  //               if (found !== undefined) {
  //                 // 👇️ this runs
  //                 console.log('✅ the object is contained in the array');
  //               } else {
  //                 console.log('⛔️ the object is NOT contained in the array');
  //                 this.list1.push(item);
  //                 //  this.changeDetectorRef.markForCheck();
  //                 this.list1 = Object.assign([], this.list1);
  //                 //console.log(this.list1);
  //               }
 
 
  //             }); 
  //           }
  //       }
  //   });
  //   console.log(this.list1);
  
  // }
 
  
 
  sourceReorder(event: any) {
    console.log('Reorder source: ', event.items);
  }
 
  moveToSource(event: any)  {
    console.log('Moved items to source: ', event.items);
 
  //   const items = event.items;
  //   items.forEach( (item : any) => {
  //     const found = this.list1.find((litem) => {
  //       return litem.name === item.name && litem.batch === item.batch;
  //     });
  //     //console.log(found); 
  //     if (found !== undefined) {
  //       console.log('✅ the object is contained in the array');
  //     } else {
  //       console.log('⛔️ the object is NOT contained in the array');
  //       this.list1.push(item);
  //     }
  //   }); 
  //  // this.list1 = Object.assign([], this.list1);
 
  //  this.list1 = [...new Set(this.list1)];
 

  //  items.forEach( (item : any) => {
  //   this.list2 = this.list2.filter(litem => {
  //     return litem.name !== item.name || litem.batch !== item.batch;
  //   });
  //   }); 
 
  //  this.list2 = [...new Set(this.list2)];
  //   console.log(this.list1);
 
   }

   saveWoProductTypeDrying() {
    //console.log('Date time', this.location);
   this.submitted = true;
   this.woProductType.dryableInputs = Object.assign([], this.listDry2);

   console.log('WO', this.woProductType );
   this.woProductType.dryableInputs.forEach( input => { input.key = input.$key; delete input.$key});

   if (this.woProductType.$key) {
     this.woProductTypes[this.findIndexById(this.woProductType.$key)] = this.woProductType;                
     this.woProductTypeService.updateWoProductType(this.woProductType);
     this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Updated', life: 3000});
   } 
   // else {
   //   // this.pallet.id = this.createId();
   //   // this.pallet.image = 'product-placeholder.svg';
   //   this.woProductTypeService.addWoProductType(this.woProductType);
   //   this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Created', life: 3000});
   //   this.woProductTypes = [...this.woProductTypes];
   // }
   this.woProductTypeDryDialog = false;
   this.woProductType = { } as WoProductType;
  }


   saveWoProductTypeCreation() {
     //console.log('Date time', this.location);
    this.submitted = true;
    this.woProductType.inputs = Object.assign([], this.list2);

    console.log('WO', this.woProductType );
    this.woProductType.inputs.forEach( input => { input.key = input.$key; delete input.$key});

    if (this.woProductType.$key) {
      this.woProductTypes[this.findIndexById(this.woProductType.$key)] = this.woProductType;                
      this.woProductTypeService.updateWoProductType(this.woProductType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Updated', life: 3000});
    } 
    // else {
    //   // this.pallet.id = this.createId();
    //   // this.pallet.image = 'product-placeholder.svg';
    //   this.woProductTypeService.addWoProductType(this.woProductType);
    //   this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Created', life: 3000});
    //   this.woProductTypes = [...this.woProductTypes];
    // }
    this.woProductTypeCreationDialog = false;
    this.woProductType = { } as WoProductType;
   }



   //
   completePosition(location : WoProductType) {
    console.log("SAVE", location);
  //  this.locationService.updateLocation(location);


    if ( this.newPosition > -1 ) {
        location.position = this.newPosition;
        location = this.checkPositionLimits(location);
        this.reorderElements(location);
        //this.updateDB(spray);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.sprays);
    // const myClonedArray = [];
    // this.sprays.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.woProductTypes.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.woProductTypes.length - 1 - event.dropIndex;
    const sprayToMove = this.woProductTypes[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.woProductTypes[index] = this.woProductTypes[index+1];
        this.woProductTypes[index].position = index;
        this.woProductTypeService.updateWoProductType(this.woProductTypes[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.woProductTypes[index] = this.woProductTypes[index-1];
        this.woProductTypes[index].position = index;
        this.woProductTypeService.updateWoProductType(this.woProductTypes[index]);
      }
    } 
    this.woProductTypes[endIndex] = sprayToMove;
    this.woProductTypes[endIndex].position = endIndex;
    this.woProductTypeService.updateWoProductType(this.woProductTypes[endIndex]);
  }

  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.woProductTypes.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, spray: WoProductType) {
    console.log("event" +event);
    if (spray.position != null && spray.position > -1) {
      this.previousPosition = spray.position;
      this.newPosition = event;
    }
   
    console.log("previous" +this.previousPosition);
    console.log("new" +this.newPosition);
  }

  checkPositionLimits(spray: WoProductType) {
    console.log('check ',spray.position + ' ' + this.woProductTypes.length);
    if (!spray.position) {
    //  console.log('check 1');
      return this.woProductType;
    }
    if (spray.position < 0) {
      spray.position = 0;
     // console.log('check 2');
      return spray;
    }
    if (spray.position > this.woProductTypes.length) {
      spray.position = this.woProductTypes.length - 1;
    //  console.log('check 3', spray.position);
      return spray;
    }
  //  console.log('check 4');
    return spray;
  }

  async reorderElements(spray: WoProductType) {
    this.newPosition = this.newPosition  > this.woProductTypes.length ? this.woProductTypes.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === spray.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const sprayToMove = this.woProductTypes[startIndex];
    console.log('Item to move: ', this.woProductTypes[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        // console.log('LOC', this.woProductTypes);
        // console.log('Item to +1: ', this.woProductTypes[index+1]);

        this.woProductTypes[index] = this.woProductTypes[index+1];
        this.woProductTypes[index].position = index;
        // console.log('Move: ', this.woProductTypes[index+1]);
        // console.log('Move pos: ', this.woProductTypes[index].position);
        //await this.updateDB(this.sprays[index]);
        this.woProductTypeService.updateWoProductType(this.woProductTypes[index]);
        //console.log('Update DB: ', this.woProductTypes[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.woProductTypes[index] = this.woProductTypes[index-1];
        this.woProductTypes[index].position = index;
        this.woProductTypeService.updateWoProductType(this.woProductTypes[index]);
      }
    } 
    this.woProductTypes[endIndex] = sprayToMove;
    this.woProductTypes[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.woProductTypeService.updateWoProductType(this.woProductTypes[endIndex]);
    
  }

}
